import React from 'react'

import MaskedInput, { MaskedInputProps } from '@/components/form/MaskedInput'

const MoneyInput: React.FC<MaskedInputProps> = ({
  placeholder = 'Add amount',
  inputGroupText = '£',
  maskOptions = {
    numeral: true,
    numeralThousandsGroupStyle: 'thousand',
  },
  ...props
}) => {
  const transformRawValue =
    props.transformRawValue ??
    function (rawValue: string) {
      const isValidNumber =
        rawValue.length > 0 && rawValue !== '-' && rawValue !== '.'
      return isValidNumber ? Number(rawValue) : undefined
    }

  return (
    <MaskedInput
      {...props}
      placeholder={placeholder}
      inputGroupText={inputGroupText}
      maskOptions={maskOptions}
      transformRawValue={transformRawValue}
    />
  )
}

export default MoneyInput
